export default __webpack_public_path__ + "static/giotto-1-5810de90f275108edd42b8926913ffa8.jpg";